// Limiares do indicador de "parado" — proxy sobre updatedAt (qualquer edição reseta, não só
// troca de estágio), mas é o único dado disponível sem agregação nova no backend. Complementa
// o alerta de atividade vencida, que é o sinal preciso. Compartilhado entre CrmBoardView e
// CrmNegocioListView.
export const DIAS_PARADO_AMBAR = 7;
export const DIAS_PARADO_VERMELHO = 14;

export function diasSemAtualizar(updatedAt?: string): number | null {
  if (!updatedAt) return null;
  const ms = Date.now() - new Date(updatedAt).getTime();
  return Math.floor(ms / (1000 * 60 * 60 * 24));
}
